import { isPlatformBrowser } from '@angular/common'
import { Component, Inject, OnInit, Optional, PLATFORM_ID, RESPONSE_INIT } from '@angular/core'
import { Response } from 'express'
import { RESPONSE } from '../../express.tokens'

@Component({
  selector: 'gea-shop-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  standalone: false
})
export class ServerErrorComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response?: Response,
    @Optional() @Inject(RESPONSE_INIT) private responseInit?: ResponseInit | null,
  ) {
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) return

    this.response?.status(503)
    if (this.responseInit) {
      this.responseInit.status = 503
    }
  }
}
